import { FaChevronDown, FaChevronUp } from 'react-icons/fa';

const OrientationModule = ({ module, moduleIndex, expandedModules, toggleModule, expandedClasses, toggleClass }) => {
    return (
        <div className="bg-white rounded-xl shadow-md overflow-hidden">
            {/* Module Header */}
            <div
                onClick={() => toggleModule(moduleIndex)}
                className="flex justify-between items-center px-6 py-4 cursor-pointer hover:bg-gray-100 transition"
            >
                <h2 className="text-xl font-semibold text-[#001670]">{module.name}</h2>
                {expandedModules[moduleIndex] ? (
                    <FaChevronUp className="text-[#001670]" />
                ) : (
                    <FaChevronDown className="text-[#001670]" />
                )}
            </div>

            {/* Expanded Module Content */}
            {expandedModules[moduleIndex] && (
                <div className="px-6 pb-4 space-y-2">
                    {module.classes.map((classItem, classIndex) => (
                        <div key={classIndex} className="border rounded-md">
                            <div
                                className="flex justify-between items-center px-4 py-3 bg-gray-50 cursor-pointer hover:bg-gray-100 transition"
                                onClick={() => toggleClass(moduleIndex, classIndex)}
                            >
                                <h3 className="font-medium text-[#001670]">{classItem.name}</h3>
                                {classItem.subClasses ? (
                                    expandedClasses[`${moduleIndex}-${classIndex}`] ? (
                                        <FaChevronUp className="text-[#001670]" />
                                    ) : (
                                        <FaChevronDown className="text-[#001670]" />
                                    )
                                ) : null}
                            </div>
                            {classItem.subClasses && expandedClasses[`${moduleIndex}-${classIndex}`] && (
                                <div className="px-4 py-2 space-y-2">
                                    {classItem.subClasses.map((subClass, subIndex) => (
                                        <div key={subIndex} className="border rounded-md">
                                            <div className="px-4 py-3 bg-gray-50 text-[#001670] font-medium">
                                                {subClass}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default OrientationModule; 